/**
 * Created by intellicar-rinas on 8/8/17.
 */
import React, { Component } from "react";
import "./LoginForm.css";
import UserAPIs from "../../APIs/UserAPIs";
import actions from "../../store/actions";
import { connect } from "react-redux";
import tracklogo from "../../assets/svg/tracklogo.svg";
// import { GoogleLogin } from "react-google-login";
import { GoogleLogin } from "@react-oauth/google";
import { save } from "../../helpers/helperFunctions";
// import mixpanel from "mixpanel-browser";


class LoginForm extends Component {
  state = {
    formBusy: false,
  };

  constructor(props) {
    super(props);

    this.isLoginFormActive = () => {
      return this.props.auth;
    };

    this.login = () => {
      const body = {
        user: {
          username: this.refs.username.value,
          password: this.refs.password.value,
        },
        impersReq: true,
      };

      const handleSuccess = (resp) => {
        this.setState({ formBusy: false, googleNotRegEmail: false });
        resp = {
          ...resp,
          loggedInAt: Date.now(),
        };
        // mixpanel.identify(resp.userinfo.userid);
        // mixpanel.people.set_once({
        //   $distinct_id: resp.userinfo.userid,
        //   $name: resp.userinfo.username,
        //   $username: resp.userinfo.username,
        //   Username: resp.userinfo.username,
        // });
        if (resp.impPerm) {
          props.dispatch({
            type: actions.AUTH_SUCCESS,
            data: resp,
          });
        } else {
          save("intelli-auth", { 0: resp }); // mimic AUTH_SUCCESS
          window.location.reload();
        }
        // mixpanel.track("User Clicked Email Login", {
        //   Platform: "Web",
        //   Application: "Web",
        //   Screen: "Login",
        // });
      };

      const handleFailure = (resp) => {
        let error = "Login Error";
        if (resp.response) error = resp.response.data.msg;
        this.setState({
          authError: error,
          formBusy: false,
          googleNotRegEmail: false,
        });
      };

      this.setState({
        authError: "",
        formBusy: true,
        googleNotRegEmail: false,
      });
      UserAPIs.login(body).then(handleSuccess, handleFailure);
    };

    this.keyDown = (e) => {
      if (e.keyCode === 13) {
        this.login();
      }
    };
  }

  initLogin(r) {
    setTimeout(() => {
      if (r) r.className += " active";
    });
  }

  isAppNameAvailable = () => {
    return !window.isWhiteLabelAvailable("nh100");
  };

  responseGoogle = (resp) => {
    if (resp.tokenId) {
      this.setState({
        googleLoginInfo: resp,
        formBusy: true,
        googleNotRegEmail: false,
        authError: "",
      });
      const handleSuccess = (resp) => {
        this.setState({ formBusy: false });
        resp = {
          ...resp,
          loggedInAt: Date.now(),
        };
        if (resp.impPerm) {
          this.props.dispatch({
            type: actions.AUTH_SUCCESS,
            data: resp,
          });
        } else {
          save("intelli-auth", { 0: resp }); // mimic AUTH_SUCCESS
          window.location.reload();
        }
        // mixpanel.track("User Clicked Google Login", {
        //   Platform: "Web",
        //   Application: "Web",
        //   Screen: "Login",
        // });
      };

      const handleFailure = (resp) => {
        if (resp.response) {
          this.setState({
            formBusy: false,
            gmRegReqSuccess: false,
            authError: resp.response.data.msg,
            googleNotRegEmail: false,
          });
          this.lastUserReqGroupId = resp.response.data.err.groupid;
          if (resp.response.data.err.valid) {
            resp.response.data.err.userAlreadyRequested === false
              ? this.registerGmail()
              : null;
            this.setState({
              authError: resp.response.data.msg,
              googleNotRegEmail: true,
              gmRegReqSuccess: false,
              gmRegPending: resp.response.data.err.userAlreadyRequested,
            });
          }
        }
      };

      UserAPIs.googleLogin({
        token: resp.tokenId,
        app: "track",
        impersReq: true,
      }).then(handleSuccess, handleFailure);
    } else {
      this.setState({
        formBusy: false,
        authError: "Login Failed",
        googleNotRegEmail: false,
      });
    }
  };

  getGmailData = () => {
    return (this.state.googleLoginInfo || {}).profileObj;
  };

  registerGmail = () => {
    let profileInfo = this.getGmailData();
    if (profileInfo) {
      this.setState({ gmRegBusy: true, authError: "" });

      const handleSuccess = (resp) => {
        this.setState({
          gmRegBusy: false,
          gmRegReqSuccess: true,
          gmRegPending: true,
        });
      };

      const handleFailure = (resp) => {
        this.setState({
          gmRegBusy: false,
          gmRegReqSuccess: false,
          gmRegPending: false,
          authError: "Access Request Failed",
          googleNotRegEmail: false,
        });
      };

      UserAPIs.requestUserAccess({
        username: profileInfo.email,
        groupid: this.lastUserReqGroupId,
      }).then(handleSuccess, handleFailure);
    }
  };

  isGoogleLoginAvailable = () => {
    return !window.isWhiteLabelAvailable();
  };

  forgotPassword = (e) => {
    e.preventDefault();
    this.props.dispatch({
      type: "FORGOT_PASSWORD",
      data: true,
    });
  };

  render() {
    return (
      <div className="LoginForm" ref={(r) => this.initLogin(r)}>
        <div className="lf-form">
          {this.isAppNameAvailable() ? (
            <div className="lff-app-name">
              {/* <object data={tracklogo} type="image/svg+xml"></object> */}
              <div className="logo">
              <img src={tracklogo} className="tracklogo" ></img>
              <span>TRACK</span>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="lff-inputs">
            <input
              placeholder="Username"
              ref="username"
              onKeyDown={this.keyDown}
            />
            <input
              type="password"
              placeholder="Password"
              onKeyDown={this.keyDown}
              ref="password"
            />
            <button className="lff-button" onClick={this.login}>
              {this.state.formBusy ? (
                <span className="in-spinner"></span>
              ) : (
                <span>LOGIN</span>
              )}
            </button>
            {this.isGoogleLoginAvailable() ? (
              <GoogleLogin
                clientId="232928276196-blbvekh295b066250ehevqht1ld3lku9.apps.googleusercontent.com"
                buttonText="Login with Google"
                onSuccess={this.responseGoogle}
                onFailure={this.responseGoogle}
                cookiePolicy={"single_host_origin"}
              />
            ) : (
              ""
            )}
            <span className="lff-error">{this.state.authError}</span>

            {!this.isGoogleLoginAvailable() ? (
              ""
            ) : this.state.googleNotRegEmail &&
              this.getGmailData() &&
              this.state.gmRegBusy ? (
              <div className="lff-gmail-reg-req">
                <div className="lff-spinner"></div> <span>Requesting</span>
              </div>
            ) : (
              ""
            )}
            <div className="lff-lnk">
              <a href="#" onClick={this.forgotPassword}>
                Forgot password?
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const MapPropsToState = (state) => {
  return { auth: state.auth };
};

export default connect(MapPropsToState)(LoginForm);
